export default {
  // Интернационализация маршрутов
  route: {
    dashboard: 'Панель управления',
    document: 'Документация'
  },
  // Интернационализация страницы входа
  login: {
    title: 'Вход',
    subTitle: 'Добро пожаловать на платформу оптовой продажи зарубежных аккаунтов',
    formLogin: 'Войти',
    formUserNamePlaceholder: 'Пожалуйста, введите имя пользователя',
    formPasswordPlaceholder: 'Пожалуйста, введите пароль',
    formUserNameErrMsg: 'Имя пользователя не может быть пустым',
    formPasswordErrMsg: 'Пароль не может быть пустым',
    formErrMsg: 'Ошибка входа, пожалуйста, обновите и попробуйте снова',
    formSuccess: 'Добро пожаловать к использованию',
    forgotPassword: 'Забыли пароль?',
    noAccount: 'Нет аккаунта?',
    register: 'Зарегистрироваться',
    slogan1: 'Строгая защита конфиденциальности, никто не может получить доступ к информации',
    subSlogan1: 'Качественные аккаунты, гарантия качества, безопасное послепродажное обслуживание',
    slogan2: 'Поддержка децентрализованных платежей через блокчейн-кошелек, удобные транзакции',
    subSlogan2: 'Интернационализация, настройка маршрутов, управление состоянием включены',
    slogan3: 'Стабильность и надежность, быстрая доставка',
    subSlogan3:
      'Профессиональное обслуживание команды, долгосрочная стабильность, постоянные обновления'
  },
  navbar: {
    退出: 'Выход'
  },
  common: {
    是: 'Да',
    否: 'Нет',
    登录成功: 'Вход выполнен успешно',
    已在其他标签页打开: 'Уже открыто в другой вкладке',
    请关闭当前标签页: 'Пожалуйста, закройте текущую вкладку',
    添加: 'Добавить',
    删除: 'Удалить',
    编辑: 'Редактировать',
    取消: 'Отмена',
    确认: 'Подтвердить',
    分组: 'Группа',
    确定删除吗: 'Вы уверены, что хотите удалить?',
    确认删除: 'Подтвердить удаление',
    搜索用户: 'Поиск пользователя',
    小时: 'Час',
    天: 'День',
    表情: 'Эмодзи',
    图片: 'Изображение',
    历史: 'История',
    快捷回复: 'Быстрый ответ',
    常用表情: 'Часто используемые эмодзи',
    手势: 'Жесты',
    心形: 'Сердца',
    自然: 'Природа',
    食物: 'Еда',
    节日: 'Праздники',
    天气: 'Погода',
    消息管理: 'Управление сообщениями',
    全部: 'Все',
    音频: 'Аудио',
    视频: 'Видео',
    文件: 'Файл',
    发送: 'Отправить',
    更多操作: 'Дополнительные действия',
    请输入消息: 'Пожалуйста, введите сообщение',
    删除成功: 'Успешно удалено',
    在线: 'Онлайн',
    离线: 'Оффлайн',
    封禁用户: 'Заблокировать пользователя',
    打开: 'Открыть',
    关闭: 'Закрыть',
    暂无数据: 'Нет данных',
    已封禁: 'Заблокирован',
    资料卡: 'Профиль',
    签名: 'Этот человек ленив и ничего не оставил',
    手机号: 'Номер телефона',
    昵称: 'Никнейм',
    性别: 'Пол',
    备注: 'Примечание',
    添加备注: 'Добавить примечание',
    邮箱: 'Email',
    发送消息: 'Отправить сообщение',
    修改备注: 'Изменить примечание',
    操作成功: 'Операция выполнена успешно',
    操作失败: 'Сервис занят, попробуйте позже',
    全选: 'Выбрать все',
    消息发送失败: 'Не удалось отправить сообщение',
    请完善表单信息: 'Пожалуйста, заполните информацию в форме',
    表单验证失败: 'Проверка формы не удалась',
    秒: 'Секунда',
    分钟前: 'минут назад',
    刚刚: 'Только что',
    昨天: 'Вчера',
    前天: 'Позавчера',
    日: 'Вс',
    一: 'Пн',
    二: 'Вт',
    三: 'Ср',
    四: 'Чт',
    五: 'Пт',
    六: 'Сб'
  },
  setting: {
    langSetting: 'Язык',
    zh: 'Китайский',
    en: 'Английский',
    pt: 'Португальский',
    ru: 'Русский'
  },
  xmlRequest: {
    501: 'Не удалось получить список',
    502: 'Имя пользователя не может быть пустым',
    503: 'Агент не найден',
    504: 'Ошибка запроса, попробуйте позже',
    505: 'Ошибка создания',
    506: 'Не существует',
    507: 'Ошибка обновления',
    508: 'Агент не существует',
    509: 'Ошибка удаления',
    510: 'Отсутствуют обязательные параметры',
    511: 'Неверное имя пользователя или пароль',
    512: 'Ошибка входа, попробуйте позже',
    513: 'Не удалось получить статистику',
    514: 'Не удалось получить тенденцию дохода',
    515: 'Пожалуйста, выберите файл для загрузки',
    516: 'Не удалось получить список заказов',
    517: 'Не удалось получить детали',
    518: 'Не удалось получить активные способы оплаты',
    519: 'Неверный формат параметра',
    401: 'Пользователь не существует или состояние входа недействительно',
    提示: 'Уведомление',
    当前登录已失效: 'Текущий вход недействителен',
    确认: 'Подтвердить',
    再想想: 'Подумать еще раз'
  },
  undefined: 'Сервис занят, попробуйте позже',
  page: {
    退出: 'Выход',
    个人信息: 'Личная информация',
    点击联系客服: 'Нажмите для связи с поддержкой',
    余额: 'Баланс',
    主页: 'Главная',
    购买账户: 'Купить аккаунт',
    购买记录: 'История покупок',
    客服: 'Поддержка',
    充值: 'Пополнить',
    登录: 'Вход',
    在线客服: 'Онлайн поддержка',
    实时订单: 'Заказы в реальном времени',
    当前在线人数: 'Текущие пользователи онлайн',
    今日售出账号: 'Аккаунтов продано сегодня',
    订单号: 'Номер заказа',
    下单时间: 'Время заказа',
    未登录: 'Не авторизован',
    账号列表: 'Список аккаунтов',
    全部: 'Все',
    库存: 'В наличии',
    价格: 'Цена',
    操作: 'Операция',
    购买: 'Купить',
    '本站售出账号请妥善保存，7天后删除数据':
      'Пожалуйста, сохраните информацию об аккаунте, данные будут удалены через 7 дней',
    请输入订单号: 'Пожалуйста, введите номер заказа',
    账号类型: 'Тип аккаунта',
    请选择账号类型: 'Пожалуйста, выберите тип аккаунта',
    购买时间: 'Время покупки',
    搜索: 'Поиск',
    重置: 'Сброс',
    充值类型: 'Тип пополнения',
    充值金额: 'Сумма пополнения',
    立即充值: 'Пополнить сейчас',
    充值通告: 'Уведомление о пополнении',
    充值记录: 'История пополнений',
    订单ID: 'ID заказа',
    请输入订单ID: 'Пожалуйста, введите ID заказа',
    发送者钱包地址: 'Адрес кошелька отправителя',
    接收者钱包地址: 'Адрес кошелька получателя',
    交易哈希: 'Хэш транзакции',
    金额: 'Сумма',
    类型: 'Тип',
    状态: 'Статус',
    时间: 'Время',
    订单编号: 'Номер заказа',
    您的钱包地址: 'Ваш адрес кошелька',
    系统钱包地址: 'Системный адрес кошелька',
    确认充值: 'Подтвердить пополнение',
    复制: 'Копировать',
    当前USDT支付区块网络协议为TRC20: 'Текущий протокол блокчейн-сети для оплаты USDT - TRC20',
    请使用链手机钱包扫码支付:
      'Пожалуйста, убедитесь, что ваш кошелек авторизован, иначе система не сможет завершить платеж',
    过程中产生的交易手续费由您自行承担: 'Комиссия за транзакцию в процессе оплачивается вами',
    时: 'Час',
    分: 'Минута',
    秒: 'Секунда',
    请输入你的钱包地址: 'Пожалуйста, введите адрес вашего кошелька',
    查看详情: 'Просмотр деталей',
    复制账号: 'Копировать аккаунт',
    进入管理端: 'Войти в админ-панель',
    进入用户端: 'Войти в пользовательский портал',
    今日已出售账号: 'Аккаунтов продано сегодня',
    用户: 'Пользователь',
    '请先安装 TronLink 钱包': 'Пожалуйста, сначала установите кошелек TronLink',
    请输入您的钱包地址: 'Пожалуйста, введите адрес вашего кошелька',
    充值详情: 'Детали пополнения',
    充值成功: 'Пополнение успешно',
    充值失败: 'Ошибка пополнения',
    充值中: 'Пополнение в процессе',
    充值状态: 'Статус пополнения',
    充值时间: 'Время пополнения',
    订单支付: 'Оплата заказа',
    应付总额: 'Итого к оплате',
    支付: 'Оплатить',
    购买数量: 'Количество покупки',
    购买成功: 'Покупка успешна',
    产品名称: 'Название продукта',
    产品描述: 'Описание продукта',
    账号: 'Аккаунт',
    密码: 'Пароль',
    支付金额: 'Сумма оплаты',
    订单状态: 'Статус заказа',
    账号信息: 'Информация об аккаунте',
    已完成: 'Завершено',
    处理中: 'В обработке',
    连接钱包: 'Подключить кошелек',
    已连接钱包: 'Кошелек подключен',
    钱包余额: 'Баланс кошелька',
    请先连接钱包: 'Пожалуйста, сначала подключите кошелек',
    未获取到钱包地址: 'Не удалось получить адрес кошелька',
    钱包连接成功: 'Кошелек успешно подключен',
    链接钱包: 'Связать кошелек',
    手机钱包App扫码支付: 'Оплата через QR-код в мобильном приложении кошелька',
    浏览器TronLink支付: 'Оплата через TronLink в браузере',
    钱包已连接: 'Кошелек подключен',
    钱包详情: 'Детали кошелька',
    请先安装TronLink钱包: 'Пожалуйста, сначала установите кошелек TronLink',
    钱包地址已复制: 'Адрес кошелька скопирован',
    复制失败: 'Ошибка копирования',
    连接钱包失败: 'Ошибка подключения кошелька',
    检查授权状态失败请刷新页面重试:
      'Не удалось проверить статус авторизации, обновите страницу и попробуйте снова',
    '授权超时，请重新尝试': 'Время авторизации истекло, попробуйте снова',
    请输入当前连接的钱包地址: 'Пожалуйста, введите адрес текущего подключенного кошелька',
    '授权请求已发送，请在钱包中确认': 'Запрос авторизации отправлен, подтвердите в кошельке',
    请先完成授权操作: 'Пожалуйста, сначала выполните авторизацию',
    '支付失败，请重试': 'Ошибка оплаты, попробуйте снова',
    请安装钱包应用: 'Пожалуйста, установите приложение кошелька',
    用户拒绝了授权请求: 'Пользователь отклонил запрос авторизации',
    获取钱包余额失败: 'Не удалось получить баланс кошелька',
    请在钱包中完成授权操作: 'Пожалуйста, выполните авторизацию в кошельке',
    授权成功: 'Авторизация успешна',
    授权失败: 'Ошибка авторизации',
    支付成功: 'Оплата успешна',
    支付失败: 'Ошибка оплаты',
    请使用手机钱包扫码: 'Пожалуйста, используйте мобильный кошелек для оплаты',
    授权成功正在处理支付: 'Авторизация успешна, оплата в процессе',
    钱包地址为空: 'Адрес кошелька пуст',
    USDT合约地址未配置: 'USDT контракт не настроен',
    系统钱包地址未配置: 'Системный адрес кошелька не настроен',
    合约交互失败: 'Ошибка взаимодействия с контрактом',
    钱包地址未获取: 'Не удалось получить адрес кошелька',
    您的USDT余额不足: 'Ваш баланс USDT недостаточен',
    授权失败请重试: 'Ошибка авторизации, попробуйте снова',
    钱包连接失败: 'Ошибка подключения кошелька',
    订单详情: 'Подробности заказа',
    最小充值金额: 'Минимальная сумма пополнения',
    最小充值金额说明: 'Пожалуйста, введите минимальную сумму пополнения и его описание',
    保持钱包状态正常:
      'Пожалуйста, убедитесь, что ваш кошелек авторизован, иначе система не сможет завершить платеж',
    继续充值: 'Продолжить пополнение',
    充值成功点击刷新返回首页:
      'Пополнение успешно, нажмите обновить, чтобы вернуться на главную страницу',
    取消: 'Отмена'
  },
  register: {
    title: 'Регистрация',
    subTitle: 'Создать новый аккаунт',
    formRegister: 'Зарегистрироваться',
    formUserNamePlaceholder: 'Пожалуйста, введите имя пользователя',
    formEmailPlaceholder: 'Пожалуйста, введите email',
    formPasswordPlaceholder: 'Пожалуйста, введите пароль',
    formConfirmPasswordPlaceholder: 'Пожалуйста, подтвердите пароль',
    formUserNameErrMsg: 'Имя пользователя не может быть пустым',
    formEmailErrMsg: 'Email не может быть пустым',
    formEmailFormatErrMsg: 'Пожалуйста, введите действительный email адрес',
    formPasswordErrMsg: 'Пароль не может быть пустым',
    formPasswordLengthErrMsg: 'Пароль должен быть не менее 6 символов',
    formConfirmPasswordErrMsg: 'Пожалуйста, подтвердите пароль',
    formPasswordNotMatchErrMsg: 'Пароли не совпадают',
    formAgreementLabel: 'Я прочитал и согласен с',
    formPrivacyLink: 'Политикой конфиденциальности',
    formAgreementAnd: 'и',
    formTermsLink: 'Условиями использования',
    formAgreementErrMsg:
      'Пожалуйста, прочтите и согласитесь с Политикой конфиденциальности и Условиями использования',
    formHaveAccount: 'Уже есть аккаунт?',
    formLoginLink: 'Войти',
    success: 'Регистрация успешна',
    error: 'Ошибка регистрации',
    inviteCode: 'Код приглашения (необязательно)'
  },
  forgotPassword: {
    title: 'Забыли пароль',
    subTitle:
      'Пожалуйста, введите ваш email адрес, мы отправим вам код подтверждения для сброса пароля',
    formEmailPlaceholder: 'Пожалуйста, введите email',
    formCodePlaceholder: 'Пожалуйста, введите код подтверждения',
    formEmailErrMsg: 'Email не может быть пустым',
    formEmailFormatErrMsg: 'Пожалуйста, введите действительный email адрес',
    formCodeErrMsg: 'Код подтверждения не может быть пустым',
    formSendCode: 'Отправить код',
    formSubmit: 'Сбросить пароль',
    formBackToLogin: 'Вернуться к входу',
    formEmailRequired: 'Пожалуйста, сначала введите email адрес',
    codeSent: 'Код подтверждения отправлен',
    codeSendError: 'Ошибка отправки кода подтверждения',
    success: 'Пароль успешно сброшен',
    error: 'Ошибка сброса пароля'
  }
};
